export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/uk.lyaml"));
at({});
};